import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import Note from './Note/Note';
import styles from './Alert.module.css';

function Alert({ text, color, customNote, note, name, mode, accessPeriod }) {
    const backgroundColor = color || '#DCDCDC';
    const isHoverMode = mode === 'hover';
    const firstLetter = text || name?.[0];

    const containerClass = `${styles['alert-container']}${
        mode && styles[`alert-container__${mode}`] ? ` ${styles[`alert-container__${mode}`]}` : ''
    }`;

    const badge = (
        <div className={containerClass}>
            <p className={`${styles['alert']}${!text ? ` ${styles['alert--rounded']}` : ''}`} style={{ backgroundColor }}>
                {firstLetter}
            </p>
        </div>
    );

    if (isHoverMode && accessPeriod) {
        return (
            <div className={styles['alert-wrapper']}>
                <Tooltip
                    title={<Note inverted name={name} customNote={customNote} note={note} accessPeriod={accessPeriod} />}
                    enterDelay={0}
                    leaveDelay={0}
                    enterNextDelay={0}
                    placement="top"
                    componentsProps={{
                        popper: {
                            sx: { zIndex: 10001 },
                        },
                        tooltip: {
                            sx: {
                                backgroundColor,
                                color: '#fff',
                                padding: '0.5rem',
                                maxWidth: 240,
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                            },
                        },
                    }}
                >
                    {badge}
                </Tooltip>
            </div>
        );
    }

    return (
        <div className={styles['alert-wrapper']}>
            {badge}
            {!isHoverMode && accessPeriod && <Note name={name} customNote={customNote} note={note} accessPeriod={accessPeriod} />}
        </div>
    );
}

Alert.propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    customNote: PropTypes.string,
    note: PropTypes.string,
    name: PropTypes.string,
    mode: PropTypes.string,
    accessPeriod: PropTypes.object,
};

export default Alert;
